module.exports = __webpack_public_path__ + "static/media/reckless_blow.bffc357a.png";